import { Component, Host, h, Element, Listen, State } from '@stencil/core';

@Component({
  tag: 'rcm-preemptive-measures-calculator',
  styleUrl: 'rcm-preemptive-measures-calculator.scss',
  shadow: true,
})
export class RcmPreemptiveMeasuresCalculator {
  @Element() el: HTMLElement;

  iframeRef!: HTMLIFrameElement;

  @State() isInitialLoad: boolean = true;

  @Listen('message', {
    target: 'window',
  })
  resizeIframe(e) {
    if (this.iframeRef.contentWindow === e.source) {
      this.iframeRef.height = `${e.data.height}px`;
      this.iframeRef.style.height = `${e.data.height}px`;
    }

    if (this.isInitialLoad) {
      this.iframeRef.classList.remove('display_none');
      this.isInitialLoad = false;
    }
  }

  render() {
    return (
      <Host>
        <iframe
          src="https://raiff.ttweb.net/drb/rcm/iframe.html"
          width="100%"
          frameBorder="0"
          ref={(el) => {
            this.iframeRef = el;
          }}
          class="display_none"
        ></iframe>
      </Host>
    );
  }
}
